// ventura-validacao-telefone-10-07e
const validDDDs = new Set(
  "11 12 13 14 15 16 17 18 19 21 22 24 27 28 31 32 33 34 35 37 38 41 42 43 44 45 46 47 48 49 51 53 54 55 61 62 63 64 65 66 67 68 69 71 73 74 75 77 79 81 82 83 84 85 86 87 88 89 91 92 93 94 95 96 97 98 99".split(" ")
);

export const normalizeBrazilCompanyPhone = value => {
  const raw = String(value == null ? "" : value).trim();

  if (!raw || !/^\+?[\d\s().-]+$/.test(raw)) {
    return null;
  }

  const digits = raw.replace(/\D/g, "");
  const national = digits.startsWith("55") &&
    [12, 13].includes(digits.length)
    ? digits.slice(2)
    : digits;

  if (![10, 11].includes(national.length)) {
    return null;
  }

  const ddd = national.slice(0, 2);
  const subscriber = national.slice(2);

  if (!validDDDs.has(ddd)) {
    return null;
  }

  const mobile = /^9\d{8}$/.test(subscriber);
  const landline = /^[2-5]\d{7}$/.test(subscriber);

  if (!mobile && !landline) {
    return null;
  }

  if (/^(\d)\1+$/.test(subscriber) || /^9(\d)\1{7}$/.test(subscriber)) {
    return null;
  }

  return `55${national}`;
};
